






















import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Logout extends Vue {
  @Prop({ default: "" }) public ruleOverview;
}
